import { Form, Input, Select } from "antd";
import * as React from "react";
import { isBusinessRuleType } from "src/business/extensions/isBusinessRuleType";
import {
  extensionScopeLabels,
  extensionTypeLabels,
} from "src/business/extensions/ZExtension";
import { maxNameLength, rxName, rxNameMsg } from "src/common/rxName";
import { trimRequired } from "src/common/validationRules";
import { SafeForm } from "src/components/SafeForm/SafeForm";
import * as layoutStyles from "src/pages/management/objects/common/ObjectCardLayout.module.less";

import { ZExtensionFormValues } from "./extensionCardPageStore";
import { ExtensionFileField } from "./ExtensionFileField";

const extensionTypeOptions = Object.entries(extensionTypeLabels).map(
  ([value, label]) => ({ value, label }),
);
const extensionScopeOptions = Object.entries(extensionScopeLabels).map(
  ([value, label]) => ({ value, label }),
);
const extensionMaxLength = maxNameLength;
const requiredMessage = "Необходимо заполнить поле";
const extensionMaxLengthMessage = `Максимальная длина ${extensionMaxLength} символов`;

type PropsExtensionMainForm = {
  form: ReturnType<typeof Form.useForm<ZExtensionFormValues>>[0];
  isNew: boolean;
  initialValues?: ZExtensionFormValues;
  onSubmit: (values: ZExtensionFormValues) => void;
  idBox?: React.ReactNode;
  saving: boolean;
};

export const ExtensionMainForm: React.FC<PropsExtensionMainForm> = ({
  form,
  idBox,
  isNew,
  initialValues,
  onSubmit,
  saving,
}) => {
  const extensionType = Form.useWatch("type", form);
  const isBusinessRule = isBusinessRuleType(extensionType);
  return (
    <SafeForm
      form={form}
      initialValues={initialValues}
      className={layoutStyles.formColumnRoot}
      layout="vertical"
      onFinish={onSubmit}
      disabled={saving}
    >
      <div className={layoutStyles.fieldsStack}>
        <Form.Item
          name="name"
          label="Название"
          rules={[
            trimRequired(requiredMessage),
            { max: extensionMaxLength },
            { pattern: rxName, message: rxNameMsg() },
          ]}
        >
          <Input disabled={!isNew} maxLength={extensionMaxLength} allowClear />
        </Form.Item>

        {idBox}

        <Form.Item name="description" label="Описание">
          <Input.TextArea allowClear />
        </Form.Item>

        <Form.Item
          name="type"
          label="Тип"
          rules={[{ required: true, message: requiredMessage }]}
        >
          <Select disabled={!isNew} options={extensionTypeOptions} />
        </Form.Item>

        {isBusinessRule && (
          <Form.Item
            name="scope"
            label="Область применения"
            rules={[{ required: true, message: requiredMessage }]}
          >
            <Select disabled={!isNew} options={extensionScopeOptions} />
          </Form.Item>
        )}

        <Form.Item
          name="file"
          label="Файл расширения"
          rules={[{ required: true, message: requiredMessage }]}
        >
          <ExtensionFileField />
        </Form.Item>

        <Form.Item
          name="version"
          label="Версия"
          rules={[
            { max: extensionMaxLength, message: extensionMaxLengthMessage },
          ]}
        >
          <Input allowClear maxLength={extensionMaxLength} />
        </Form.Item>
      </div>
    </SafeForm>
  );
};
